const returnPathKey = 'plugin-oauth-return-path';

// Open synchronously from a click; the fresh authorization URL can arrive later.
export function preparePluginOAuthWindow(): Window | null {
  const popup = window.open('about:blank', '_blank');
  if (popup) {
    try {
      popup.sessionStorage.setItem(
        returnPathKey,
        window.location.pathname +
          window.location.search +
          window.location.hash,
      );
    } catch {
      // Storage restrictions must not prevent authorization itself.
    }
  }
  return popup;
}

export function getPluginOAuthReturnPath(): string {
  try {
    const path = window.sessionStorage.getItem(returnPathKey);
    if (path?.startsWith('/') && !path.startsWith('//')) {
      const url = new URL(path, window.location.origin);
      if (url.origin === window.location.origin) {
        return url.pathname + url.search + url.hash;
      }
    }
  } catch {
    // Fall back to this workbench when the stored path cannot be used.
  }
  return '/space';
}

export function returnFromPluginOAuth(): void {
  try {
    if (
      window.opener &&
      !window.opener.closed &&
      window.opener.location.origin === window.location.origin
    ) {
      // All mounted authorization lists refresh on focus, including chat launches.
      window.opener.dispatchEvent(new Event('focus'));
      window.opener.focus();
      window.close();
      return;
    }
  } catch {
    // A browser may detach the opener during the provider's redirect.
  }
  window.location.replace(getPluginOAuthReturnPath());
}
